import { gql } from '@apollo/client'

export const UPDATE_SITE_AGREEMENT = gql`
  mutation UPDATE_SITE_AGREEMENT($id: ID!, $agreement: AgreementInput!) {
    updateAgreementAdmin(id: $id, agreement: $agreement) {
      id
    }
  }
`
